import Shimmer from "components/ui/shimmer"
import useWindowDimensions from "helpers/window-dimensions"

const TextareaSkeleton = () => {
  const { isMobile } = useWindowDimensions()
  return (
    <div className="contained-wide tablet:px-32 widescreen:px-60 widescreen:py-60 mx-auto px-16 py-32 text-center">
      <Shimmer
        className="mb-24 w-full"
        style={{
          aspectRatio: isMobile ? "750 / 632" : "3838 / 1642",
        }}
      />
      <Shimmer
        className="h-(--base-height) tablet:h-(--tablet-height) tablet:mb-24 tablet:w-1/2 mx-auto mb-8 w-3/4"
        style={{
          "--base-height": "24px",
          "--tablet-height": "40px",
        }}
      />
      <Shimmer className="mx-auto" style={{ height: "44px", width: "220px" }} />
    </div>
  )
}

export default TextareaSkeleton
